export const RQ_GET_CHEMIST_VISIT_SUMMARY_API = {
  url:'reports/web/effort/chemistVisitSummary/<%= locationId %>/<%= fromYearMonthDate %>/<%= toYearMonthDate %>',
  method:'GET',
  auth:true,
};
